import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./travelgallery.css";

const TravelGallery = () => {

  const { country } = useParams();

  const texts = {
    italy: {
      title: "Italy",
      description: "A gallery around Italy: Firenze, Bologna.\n Florence, capital of Italy’s Tuscany region, is home to many masterpieces of Renaissance art and architecture. \n Bologna is the lively, historic capital of the Emilia-Romagna region, in northern Italy."
    },
    romania: {
      title: "Romania",
      description: "A gallery around Romania: From Transilvanya to Dobrogea. I've been in Cluj, Hunedoara, Sibiu, Sighisoara, Brasov, Bucharest, Constanta, Busteni, Predeal, Sinaia."
    },
    bulgaria: {
      title: "Bulgaria",
      description: "A gallery around Bulgaria."
    },
    switzerland: {
        title: "Switzerland",
        description: "A gallery around Switzerland: Zurich, Interlaken, Lauterbrunnen, Murren, Allmendhubel, Laussenne."
    },
    germany: {
        title: "Germany",
        description: "A gallery around Germany: Zurich, Interlaken, Lauterbrunnen, Murren, Allmendhubel, Laussenne."
    }
  };

  const pageText = texts[country] || {
    title: country,
    description: `A gallery around ${country}.`
  };


  const [mediaItems, setMediaItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {

    fetch(`https://iulianamihai.com/api/cloudinary/travel/${country}`)
      .then(res => res.json())
      .then(data => {

        const items = data.map(file => {

          const name = file.public_id
            .split("/")
            .pop()
            .replace(/_[a-z0-9]+$/, "")
            .replace(/[-_]/g, " ") + ".";

          return {
            type: file.resource_type,      // image sau video
            src: file.secure_url,
            alt: name,
            poster: file.context?.alt || null
          };

        });

        setMediaItems(items);

      })
      .catch(err => console.log("API error:", err));

    }, [country]);

  const handleClick = (index) => {
    setActiveIndex(index);
  };

  const closeLightbox = () => {
    setActiveIndex(null);
  };

  const showPrev = () => {
    setActiveIndex(prev =>
      prev > 0 ? prev - 1 : mediaItems.length - 1
    );
  };

  const showNext = () => {
    setActiveIndex(prev =>
      prev < mediaItems.length - 1 ? prev + 1 : 0
    );
  };

  return (
    <div className="containerTravelGallery">

      <div className="titleandtextTravelGallery">
        <h1 className="titleTravelGallery">{pageText.title}</h1>

        <span className="textTravelGallery">
          <div style={{ whiteSpace: "pre-line" }}>
            {pageText.description}
          </div>
          <br /> → Tap any image to view it in full size. Use the arrows to navigate left and right.
        </span>
      </div>

      <div className="gridTravelGallery">

        {mediaItems.map((item, index) => (

          <div
            key={index}
            className="thumbTravelGallery"
            onClick={() => handleClick(index)}
          >

            {item.type === "video" ? (

              <video
                src={item.src}
                poster={item.poster || ""}
                muted
                playsInline
                preload="metadata"
              />

            ) : (

              <img src={item.src} alt={item.alt} />

            )}

          </div>

        ))}

      </div>

      {activeIndex !== null && (

        <div className="lightboxTravelGallery" onClick={closeLightbox}>

          <button
            className="nav prev"
            onClick={(e) => {
              e.stopPropagation();
              showPrev();
            }}
          >
            ‹
          </button>

          <div
            className="lightboxContentTravelGallery"
            onClick={(e) => e.stopPropagation()}
          >

            {mediaItems[activeIndex].type === "video" ? (

              <video
                src={mediaItems[activeIndex].src}
                poster={mediaItems[activeIndex].poster || ""}
                controls
                autoPlay
              />

            ) : (

              <img
                src={mediaItems[activeIndex].src}
                alt={mediaItems[activeIndex].alt}
              />

            )}

            <p className="lightboxCaptionTravelGallery">
              {mediaItems[activeIndex].alt}
            </p>

          </div>

          <button
            className="nav next"
            onClick={(e) => {
              e.stopPropagation();
              showNext();
            }}
          >
            ›
          </button>

          <button
            className="close"
            onClick={(e) => {
              e.stopPropagation();
              closeLightbox();
            }}
          >
            ×
          </button>

        </div>

      )}

    </div>
  );
};

export default TravelGallery;